// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { localActions as actions } from '.';

// function* doSomething() {}

export function* webphoneSaga() {
  // yield takeLatest(actions.someAction.type, doSomething);
}
